import { Box, Button, Grid } from '@mui/material'
import { CarrierVisitScheduleTimings } from '@planning/components/CarrierVisitScheduleTimings'
import {
  RailVisitTrackAndTimingFormStore,
  RailVisitType,
} from '@planning/pages/RailVisit/stores/RailVisitTrackAndTimingFormStore'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'

export const RailVisitTypeSelector = observer(
  ({ store }: { store: RailVisitTrackAndTimingFormStore }) => {
    // TODO: use translations
    const { t } = useTranslate()

    const options: RailVisitType[] = ['singleVisit', 'repeatingVisit']
    return (
      <>
        <Grid size={{ xs: 12 }}>
          <Box display='flex' gap={1}>
            {options.map(option => (
              <Button
                key={option}
                size='small'
                variant='contained'
                color={store.visitType.value === option ? 'secondary' : 'inherit'}
                onClick={() => {
                  store.visitType.setValue(option)

                  store.schedule.showTimingOptions.setValue(option === 'repeatingVisit' ? 1 : 0)
                }}
              >
                {t(option)}
              </Button>
            ))}
          </Box>
        </Grid>

        {store.visitType.value === 'repeatingVisit' && (
          <Grid size={{ xs: 12 }} mb={'2rem'}>
            <CarrierVisitScheduleTimings
              schedule={store.schedule.data}
              onChange={val => store.schedule.setData(val)}
            />
          </Grid>
        )}
      </>
    )
  },
)
